import type { FaireCollectionEntity } from "../../entity_types/collection";

export const col_kitchen_tabletop: FaireCollectionEntity = {
  token: "col_kitchen-tabletop",
  type: "collection",
  name: "Kitchen & Tabletop",
  description: "Functional and beautiful kitchen essentials.",
  thumbnailUrl:
    "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&h=400&fit=crop",
  season: "everyday",
  itemCount: 98,
  brandToken: "catalog_brand_audreys_home_gift",
  productTokens: [],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
